'use client';
import { PlanType } from '@/utils/type/price';
import dynamic from 'next/dynamic';
const PriceBlockCourses = dynamic(() => import('@/components/Price/PriceBlockCourses'), {
  ssr: false,
});

interface PriceBlockCoursesProps {
  title?: string;
  useDefault: boolean;
  tiers: PlanType[];
  groupTiers: PlanType[];
  pairTiers: PlanType[];
  individualTiers: PlanType[];
  metaData: string;
}
export default function PriceBlockCoursesClient({
  title,
  useDefault,
  tiers,
  individualTiers,
  metaData,
  groupTiers,
  pairTiers,
}: PriceBlockCoursesProps) {
  return (
    <PriceBlockCourses
      title={title}
      useDefault={useDefault}
      tiers={tiers}
      individualTiers={individualTiers}
      groupTiers={groupTiers}
      pairTiers={pairTiers}
      metaData={metaData}
    />
  );
}
